import React, { useEffect, useRef, useState } from 'react';

const HowWeWork = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const workPrinciples = [
  {
    title: "Discovery",
    description: "We understand the problem, the data, and the organisational context."
  },
  {
    title: "Design",
    description: "We design AI systems and learning programmes grounded in proven methods."
  },
  {
    title: "Build & Enable",
    description: "We develop, deploy, and teach — ensuring systems work and teams understand them."
  },
  {
    title: "Deploy & Support",
    description: "We support rollout, adoption, and long-term use in production."
  }];


  return (
    <section
      ref={sectionRef}
      className="relative min-h-screen bg-white text-black py-32 px-6 md:px-12 overflow-hidden">

      {/* Background Image */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://images.pexels.com/photos/1109541/pexels-photo-1109541.jpeg"
          alt="Abstract architectural planning"
          className="w-full h-full object-cover" />

      </div>

      <div className="container mx-auto max-w-6xl relative z-10">
        <h2
          className="text-5xl md:text-7xl lg:text-8xl font-bold mb-20 tracking-tight"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 1s ease-out, transform 1s ease-out'
          }}>

          How we work
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-20">
          {workPrinciples.map((principle, index) =>
          <div
            key={index}
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
              transition: `opacity 0.8s ease-out ${0.2 + index * 0.15}s, transform 0.8s ease-out ${0.2 + index * 0.15}s`
            }}>

              <h3 className="text-3xl md:text-4xl font-bold mb-4">
                {principle.title}
              </h3>
              <p className="md:text-2xl !text-xl text-gray-700">
                {principle.description}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default HowWeWork;